module.exports = __webpack_public_path__ + "img/mickey138.c43a450b.jpg";